import React, {Component} from "react";

import Layer1 from "../layers/Layer1"
import Layer2 from "../layers/Layer2"
import ShowLocation from "../layers/Layer3/Location"
import AddSchool from "../layers/Layer3/AddSchool"
import Layer4 from "../layers/Layer4"
import { useParams } from 'react-router-dom'
import useGlobal from "../store";

import "./index.scss";

const Location = (props) => {
    let [currentState, currentActions] = useGlobal();
    const { location } = useParams()
    return  (
        <div className="ui-main location">
            <Layer1 context="site" entityId={location} />
            <Layer2 submodule={currentState.currentModule} context="Site" />
            { props.add && props.school ? <AddSchool /> : <ShowLocation location={location} /> }
            <Layer4 />
        </div>
    )
}

export default Location